import Corporate from '@/views/corporate/Corporate.vue'
import ClientInnerTabCorporateCaptable from '@/components/client/corporate/InnerTabCorporateCaptable.vue'
import ClientInnerTabCorporateAdministration from '@/components/client/corporate/InnerTabCorporateAdministration.vue'
import ClientInnerTabCorporateHistoric from '@/components/client/corporate/InnerTabCorporateHistoric.vue'

const corporateRouter = (beforeEnter) => {
    return {
        beforeEnter: beforeEnter,
        name: 'Societario',
        path: '/societario',
        meta: {
            requiresAuth: true,
            breadcrumb: true,
            breadcrumbName: 'Societário',
            layout: 'default'
        },
        component: Corporate,
        children: [
            {
                beforeEnter: beforeEnter,
                name: 'ClienteSocietarioCaptable',
                path: '/societario/captable',
                meta: {
                    requiresAuth: true,
                    isEmployee: true,
                    layout: 'default'
                },
                props: true,
                component: ClientInnerTabCorporateCaptable
            },
            {
                beforeEnter: beforeEnter,
                name: 'ClienteSocietarioAdministracao',
                path: '/societario/administracao',
                meta: {
                    requiresAuth: true,
                    isEmployee: true,
                    layout: 'default'
                },
                props: true,
                component: ClientInnerTabCorporateAdministration
            },
            {
                beforeEnter: beforeEnter,
                name: 'ClienteSocietarioAtoConstitutivo',
                path: '/societario/atos-constitutivos',
                meta: {
                    requiresAuth: true,
                    isEmployee: true,
                    layout: 'default',
                    singleName: 'Cliente'
                },
                props: true,
                component: ClientInnerTabCorporateHistoric
            }
        ]
    }
}

export default corporateRouter
